module.exports = __webpack_public_path__ + "img/console08.fbaf429c.jpg";